export default "__VITE_ASSET__DGOl29pk__"